import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomePageRoutingModule } from './modules/home/home-routing.module';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/auth/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: '',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  
  // {
  //   path: 'dashboard',
  //   loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
  // },
  // {
  //   path: 'sanna',
  //   loadChildren: () => import('./modules/sanna/sanna.module').then((m) => m.SannaPageModule),
  // },
  // {
  //   path: 'medical-license-records',
  //   loadChildren: () =>
  //     import('./modules/medical-license-records/medical-license-records.module').then(
  //       (m) => m.MedicalLicenserecordsPageModule,
  //     ),
  // },
  // {
  //   path: 'citizen-attention',
  //   loadChildren: () => import('./modules/citizen-attention/citizen-attention.module').then( m => m.CitizenAttentionPageModule)
  // },
  // {
  //   path: 'trainings',
  //   loadChildren: () => import('./modules/trainings/trainings.module').then( m => m.TrainingsPageModule)
  // },
  // {
  //   path: 'documents',
  //   loadChildren: () => import('./modules/documents/documents.module').then( m => m.DocumentsPageModule)
  // },
  // {
  //   path: 'communications',
  //   loadChildren: () => import('./modules/communications/communications.module').then( m => m.CommunicationsPageModule)
  // },
  // {
  //   path: 'service-desk',
  //   loadChildren: () => import('./modules/service-desk/service-desk.module').then( m => m.ServiceDeskPageModule)
  // },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
